import $ from 'jquery';

export default function () {

  var resetFilters = {

    __init: function ($) {



      $( 'input.clear-filters' ).click( function (e) {
        $(this).siblings('.search-form').find('input[type=checkbox]').prop('checked', false);
        return e.preventDefault();
      })

    }
  };

  resetFilters.__init($);

}
